import script from "./TableData.vue?vue&type=script&setup=true&lang=js"
export * from "./TableData.vue?vue&type=script&setup=true&lang=js"

import "./TableData.vue?vue&type=style&index=0&id=1d5b174b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d5b174b"]])

export default __exports__